import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLeaderboard } from '../features/leaderboard/hooks/useLeaderboard';
import { LeaderboardTop } from '../features/leaderboard/components/LeaderboardTop';
import { LeaderboardFilters } from '../features/leaderboard/components/LeaderboardFilters';
import { LeaderboardList } from '../features/leaderboard/components/LeaderboardList';
import { Trophy } from 'lucide-react';

const LeaderboardPage: React.FC = () => {
  const { t } = useTranslation('common');
  const { leaderboard, timeFilter, setTimeFilter } = useLeaderboard();

  return (
    <div className="min-h-screen bg-[#f8fafc] p-4 md:p-6 lg:p-8 pb-12">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-8 gap-3">
          <div className="p-3 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full shadow-lg text-white mb-2">
            <Trophy size={40} />
          </div>
          <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight">
            {t('leaderboard.header.title')}
          </h1>
          <p className="text-xl text-gray-500 max-w-lg">
            {t('leaderboard.header.subtitle')}
          </p>
        </div>

        <LeaderboardFilters
          timeFilter={timeFilter}
          onChange={setTimeFilter}
        />

        <LeaderboardTop entries={leaderboard.slice(0, 3)} />

        <LeaderboardList entries={leaderboard.slice(3)} />
      </div>
    </div>
  );
};

export default LeaderboardPage;
